/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SpinUpPreviewResponse
 */
export interface SpinUpPreviewResponse {
  /**
   *
   * @type {boolean}
   * @memberof SpinUpPreviewResponse
   */
  accepted: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SpinUpPreviewResponse
   */
  reboot: boolean;
}

/**
 * Check if a given object implements the SpinUpPreviewResponse interface.
 */
export function instanceOfSpinUpPreviewResponse(
  value: object,
): value is SpinUpPreviewResponse {
  if (!("accepted" in value) || value["accepted"] === undefined) return false;
  if (!("reboot" in value) || value["reboot"] === undefined) return false;
  return true;
}

export function SpinUpPreviewResponseFromJSON(
  json: any,
): SpinUpPreviewResponse {
  return SpinUpPreviewResponseFromJSONTyped(json, false);
}

export function SpinUpPreviewResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SpinUpPreviewResponse {
  if (json == null) {
    return json;
  }
  return {
    accepted: json["accepted"],
    reboot: json["reboot"],
  };
}

export function SpinUpPreviewResponseToJSON(json: any): SpinUpPreviewResponse {
  return SpinUpPreviewResponseToJSONTyped(json, false);
}

export function SpinUpPreviewResponseToJSONTyped(
  value?: SpinUpPreviewResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    accepted: value["accepted"],
    reboot: value["reboot"],
  };
}
